import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const categoriesBackgroundColors = [
  BackgroundColor.STONE,
  BackgroundColor.MINT_TINT,
  BackgroundColor.LIME_TINT,
  BackgroundColor.PURPLE_TINT,
  BackgroundColor.BERRY_TINT,
  BackgroundColor.ORANGE_TINT,
  BackgroundColor.WHITE,
  BackgroundColor.GREY_FACET
] as const

export type CategoriesBackgroundColor =
  (typeof categoriesBackgroundColors)[number]
